import React from 'react';
import PendingRCsSection from '../components/PendingRCsSection';

const PendingRCsPage = () => {
    return (
        <div className="p-6">
            <div className="mb-6">
                <h1 className="text-2xl font-bold text-gray-900">Gestión de RCs Pendientes</h1>
                <p className="text-gray-600 mt-2">
                    Pedidos con pagos registrados pero sin Recibo de Caja (RC) creado en Siigo
                </p>
            </div>

            <PendingRCsSection />
        </div>
    );
};

export default PendingRCsPage;
